import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const NumberCircleSeven: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-72.12 0-139.92-28.08-190.92-79.08s-79.08-118.8-79.08-190.92 28.08-139.92 79.08-190.92 118.8-79.08 190.92-79.08 139.92 28.08 190.92 79.08 79.08 118.8 79.08 190.92-28.08 139.92-79.08 190.92-118.8 79.08-190.92 79.08zm0-510c-64.11 0-124.38 24.96-169.71 70.29s-70.29 105.6-70.29 169.71 24.96 124.38 70.29 169.71 105.6 70.29 169.71 70.29 124.38-24.96 169.71-70.29 70.29-105.6 70.29-169.71-24.96-124.38-70.29-169.71-105.6-70.29-169.71-70.29z' />
    <path d='m324.38 512.27 113.85-225.21v-1.99h-131.25v-27.34h163.07v28.84l-113.35 225.71h-32.31z' />
  </IconBase>
));

NumberCircleSeven.displayName = 'NumberCircleSeven';

export default NumberCircleSeven;
